<template>
    <dropdown-input @select="onSelect"
                    :firstSelected="date"
                    :options="options"
                    label="למתי בערך?"
                    placeholder="למתי בערך?"></dropdown-input>
</template>

<script>
import dateUtils from '@/utils/dates';
import DropdownInput from '@/base-components/DropdownInput';
import { mapState } from 'vuex';
import _ from 'lodash';

const MAX_MONTHS_DIFF = 24;

export default {
  name: 'MonthYearPicker',
  components: {
    DropdownInput,
  },
  data() {
    return {
      options: [],
      date: null,
    };
  },
  created() {
    const monthList = dateUtils.generateMonthsList(MAX_MONTHS_DIFF);
    this.options = monthList.map(item => { return { value: item, label: this.prettyName(item) }; });
    if (this.currentPlan.deadline) {
      this.date = _.find(this.options, ({ value }) => this.prettyName(value) === this.prettyName(this.currentPlan.deadline)).value;
    }
  },
  computed: {
    ...mapState('planAhead', ['currentPlan']),
  },
  methods: {
    prettyName(monthYear) {
      return dateUtils.getMonthAndYear(monthYear);
    },
    onSelect(option) {
      this.$emit('select', option);
    },
  },
};
</script>
